import {
  Row,
  Divider,
} from "antd";
import get from "lodash/get";
import GraphGrid from "../graphGrid";
import { getTransformedMinutes } from "../../../utilities/helpers";
import round from "lodash/round";

const ExtrutionContent = ({selectedTemplate, filter,data}) => {
  return (
       <Row id="content-container ">
        <GraphGrid
          graphId={1}
          type="day"
          stats={get(data, "on_off_graph", [])}
          label={"On / Off / Idle"}
          statistics={[
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_off_hours", 0)?round(get(selectedTemplate, "meta.total_off_hours", 0)):0
              ),
              // value:get(selectedTemplate, "meta.total_off_hours"),
              label: "Off Hours",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_idle_hours", 0)?round(get(selectedTemplate, "meta.total_idle_hours", 0)):0
              ),
              label: "Idle  Hours",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_working_hours", 0)?round(get(selectedTemplate, "meta.total_working_hours", 0)):0
              ),
              label: "Working Hours",
            },
          ]}
            selectedTemplate={selectedTemplate}
           filter={filter}
        />
        <Divider />
        <GraphGrid
          graphId={2}
          type="day"
          label={"length"}
          stats={get(data, "length_graph", [])}
          statistics={[
            {
              value: `${get(selectedTemplate, "meta.total_length", 0)?round(get(selectedTemplate, "meta.total_length", 0)):0} Meter`,
              label: "Total length",
            },
          ]}
            selectedTemplate={selectedTemplate}
           filter={filter}
        />
        <Divider />
        <GraphGrid
          type="day"
          graphId={3}
          label={"Speed"}
          stats={get(data, "speed_graph", [])}
          statistics={[
            {
                 value: get(selectedTemplate, "meta.avg_machine_speed")?`${round(get(selectedTemplate, "meta.avg_machine_speed"))} Meter/min`:'0 Meter/min',
                label: "Avg. Speed",
            },
          ]}
                     filter={filter}
                        selectedTemplate={selectedTemplate}
        />
        <Divider />
        {get(data, "power_consumption_graph") && (
          <GraphGrid
            type="day"
            graphId={4}
            label={"Power Consumption"}
            stats={get(data, "power_consumption_graph", [])}
            statistics={[
              {
                value: `${get(
                  selectedTemplate,
                  "meta.total_power_consumption",
                  0
                )?round(get(
                  selectedTemplate,
                  "meta.total_power_consumption",
                  0
                )):0} Kwh`,
                label: "Power Consumption",
              },
            ]}
                        filter={filter}
                        selectedTemplate={selectedTemplate}
          />
        )}
      </Row>
  )
}

export default ExtrutionContent